import { ButtonBase, Menu, MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'

import { getTranslate } from '../../localization'
import { RateConnectionChannelFieldsType } from '../../types/rateConnection'

interface PriceClassDistributionChannelRowMenuProps {
  items: RateConnectionChannelFieldsType[]
  onChangeSelectedItem: (fieldType: RateConnectionChannelFieldsType) => void
  activeItem: string
}

const PriceClassDistributionChannelRowMenu: React.FC<
  PriceClassDistributionChannelRowMenuProps
> = ({ items, onChangeSelectedItem, activeItem }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const handleOpenMenu = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleChangeMenuItem = (
    selectedItem: RateConnectionChannelFieldsType
  ) => {
    onChangeSelectedItem(selectedItem)
    handleCloseMenu()
  }

  return (
    <>
      <ButtonBase aria-controls="simple-menu" onClick={handleOpenMenu}>
        <Typography variant="h5">
          {getTranslate(activeItem).slice(0, 9)}
          {getTranslate(activeItem).length > 9 ? '...' : ''}
        </Typography>
      </ButtonBase>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}>
        {items.map((mItem) => {
          return (
            <MenuItem
              key={mItem}
              value={mItem}
              onClick={() => handleChangeMenuItem(mItem)}>
              {getTranslate(mItem)}
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

export default PriceClassDistributionChannelRowMenu
